var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"pa-4",attrs:{"cols":"auto"}},[_c('span',{staticStyle:{"text-align":"left"},domProps:{"innerHTML":_vm._s(_vm.infoContent)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }